module.exports = __webpack_public_path__ + "static/scale-model-of-shore-park-in-worcester-massachusetts-2fc7b4433ad6b3e51ebd34c75a4d81dc.png";